import { IAPIParameters } from '@cian/mf-registry-legacy/browser';

import { ISetRegionIdParameters } from '../../../../../shared/common/repositories/header-frontend/v1/get-header-microfrontend/microfrontend/api/v1/set-region-id/types';
import { ensureMicrofrontend } from '../../../../utils/ensureMicrofrontend';

export async function setRegionId(parameters: ISetRegionIdParameters): Promise<void> {
  const microfrontend = await ensureMicrofrontend('header-frontend');

  return microfrontend?.call('/v1/set-region-id/', parameters as unknown as IAPIParameters);
}
